import { computed, reactive, ref } from 'vue';

import { getUrlSearchParam } from '@/helpers/navigator/navigator';
import { getGrowthBookFeatureValue, GrowthBookFeatures } from '@/services/growth-book/growth-book';
import { getState } from '@/store/store-helper';

export function useSplitAuthorizationFee() {
  const variant = ref<GrowthBookFeatures['authorization-fee']>('def');
  const isInited = ref(false);
  const isV2 = computed(() => variant.value === 'v2');
  const isV3 = computed(() => variant.value === 'v3');
  const isSplitGroup = computed(() => isV2.value || isV3.value);

  async function init() {
    try {
      variant.value = (await getGrowthBookFeatureValue('authorization-fee', 'def', {
        lp_t: getUrlSearchParam(getState().common.index.landingUrl, 't') ?? '',
      })) as GrowthBookFeatures['authorization-fee'];
    } finally {
      isInited.value = true;
    }
  }

  return reactive({ variant, isInited, isV2, isV3, isSplitGroup, init });
}
